export default "__VITE_ASSET__89d31879__"